import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { QRCodeSVG } from "qrcode.react";
import { Printer, ArrowLeft } from "@phosphor-icons/react";
import { Button } from "../components/ui/button";
import { AuthImg } from "../components/common";
import { useApi, responderUrl } from "../lib/api";

export default function LostPoster() {
  const { pid } = useParams();
  const api = useApi();
  const [p, setP] = useState(null);
  useEffect(() => { api.get(`/people/${pid}`).then((r) => setP(r.data)); }, [api, pid]);
  if (!p) return <div className="text-slate-400">Loading…</div>;
  const m = p.medical || {};
  const meta = [m.species, m.breed, m.colour, m.sex].filter(Boolean).join(" · ");
  return (
    <div data-testid="lost-poster-page">
      <div className="flex flex-wrap gap-2 mb-6 print:hidden">
        <Button variant="outline" asChild><Link to={`/app/profile/${pid}`} data-testid="poster-back-btn"><ArrowLeft size={16} className="mr-1" />Back to profile</Link></Button>
        <Button className="bg-red-600 hover:bg-red-500 text-white" onClick={() => window.print()} data-testid="poster-print-btn"><Printer size={16} className="mr-1" />Print poster</Button>
      </div>
      {!p.personal_token && <p className="text-amber-300 text-sm mb-4 print:hidden" data-testid="poster-no-qr">Save the pet profile first so the poster gets its QR code.</p>}
      <div className="print-sheet bg-white text-[#16294A] max-w-[640px] mx-auto rounded-xl p-8 text-center" style={{ fontFamily: "Sora, sans-serif" }} data-testid="lost-poster">
        <div className="bg-[#D7263D] text-white rounded-lg py-4 text-5xl sm:text-6xl font-extrabold tracking-tight" data-testid="poster-title">LOST {(m.species || "PET").toUpperCase()}</div>
        <div className="mt-6 flex justify-center">{p.has_photo ? <AuthImg path={`/people/${pid}/photo`} className="w-72 h-72 object-cover rounded-xl border-4 border-[#16294A]" />
          : <div className="w-72 h-72 rounded-xl bg-slate-200 flex items-center justify-center text-6xl font-extrabold">{p.first_name[0]}</div>}</div>
        <div className="mt-5 text-5xl font-extrabold" data-testid="poster-name">{p.first_name}</div>
        {meta && <div className="mt-1 text-lg text-slate-600" data-testid="poster-meta">{meta}</div>}
        {p.lost?.note && <div className="mt-3 text-lg" data-testid="poster-note">Last seen: {p.lost.note}</div>}
        {p.lost?.reward && <div className="mt-4 inline-block rounded-full bg-[#FFE3E7] text-[#D7263D] text-2xl font-extrabold px-6 py-2" data-testid="poster-reward">REWARD: {p.lost.reward}</div>}
        <div className="mt-6 flex items-center justify-center gap-6 text-left">
          {p.personal_token && <QRCodeSVG value={responderUrl(p.personal_token, "qr")} size={150} level="M" data-testid="poster-qr" />}
          <div><div className="text-xl font-extrabold">Seen {p.first_name}?</div><div className="text-sm text-slate-600 mt-1 max-w-[220px]">Scan the code to tell the owner where you are, or call:</div>
            {m.owner_phone && <div className="text-2xl font-extrabold mt-2" data-testid="poster-phone">{m.owner_phone}</div>}</div>
        </div>
        <div className="mt-6 text-xs text-slate-500">bsafe.today · Every second counts</div>
      </div>
    </div>
  );
}
